import Vue from 'vue'
import {
  Button,
  Form,
  FormItem,
  Input,
  Container,
  Aside,
  Header,
  Main,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Tooltip,
  Pagination,
  Dialog,
  Checkbox,
  CheckboxGroup,
  Popconfirm,
  Popover,
  Tree,
  Alert,
  Row,
  Col,
  Select,
  Option,
  OptionGroup,
  Radio,
  Card,
  Link,
  Message,
  MessageBox,
  Cascader,
  Upload,
  DatePicker,
  Image,
  Notification,
  Progress,
  Badge,
  Loading,
  transfer,
  Steps,
  Step,
  Timeline,
  TimelineItem
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Header)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Tree)
Vue.use(Alert)
Vue.use(Row)
Vue.use(Col)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Radio)
Vue.use(Card)
Vue.use(Link)
Vue.use(Cascader)
Vue.use(Upload)
Vue.use(DatePicker)
Vue.use(Image)
Vue.use(Progress);
Vue.use(Badge);
Vue.use(Loading);
Vue.use(transfer);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Timeline);
Vue.use(TimelineItem);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
